import {
    HttpClient,
    HttpErrorResponse,
    HttpHeaders,
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { RequestService } from '../request/request.service'
import { BehaviorSubject, Observable, tap } from 'rxjs'
import { Pagination } from '../../models/pagination.interface'
import { QueryGet } from '../../shared/query-types'
import {
    SocioEconomicStatus,
    SocioEconomicStatusDTO,
} from '../../models/socioeconomicstatus.interface'
import { AsyncFormValidation } from '../../interceptors/error.interceptor'

@Injectable({
    providedIn: 'root',
})
export class SocioeconomicstatusService {
    httpOptions = {
        headers: new HttpHeaders({}),
    }
    private apiUrl = environment.service_1 + 'socioeconomic-status/'
    private socioeconomics = new BehaviorSubject<SocioEconomicStatus[]>([])
    socioeconomics$ = this.socioeconomics.asObservable()

    private socioEconomicsSelected =
        new BehaviorSubject<SocioEconomicStatus | null>(null)
    $socioEconomicsSelected = this.socioEconomicsSelected.asObservable()

    private asyncErrorValidation =
        new BehaviorSubject<AsyncFormValidation | null>(null)
    asyncErrorValidation$ = this.asyncErrorValidation.asObservable()

    constructor(
        private requestService: RequestService,
        private http: HttpClient
    ) {}

    setSocioEconomics(socioeconomics: SocioEconomicStatus[]) {
        this.socioeconomics.next(socioeconomics)
    }

    setSocioEconomic(socioEconomic: SocioEconomicStatus) {
        this.socioEconomicsSelected.next(socioEconomic)
    }

    allSocioEconomic(): Observable<SocioEconomicStatus[]> {
        return this.http.get<SocioEconomicStatus[]>(this.apiUrl, {
            headers: this.httpOptions.headers,
        })
    }

    allSocioEconomics(
        queryParams: QueryGet
    ): Observable<Pagination<SocioEconomicStatus[]>> {
        return this.requestService.get<SocioEconomicStatus[]>(
            this.apiUrl,
            queryParams
        )
    }

    deleteSocioEconomic(id: number): Observable<void> {
        return this.http.delete<void>(this.apiUrl + id + '/')
    }

    updateSocioEconomic(
        id: number,
        socioEconomic: SocioEconomicStatusDTO & { id: number }
    ) {
        return this.http
            .put<SocioEconomicStatus>(this.apiUrl + id + '/', socioEconomic)
            .pipe(
                tap({
                    error: (err: HttpErrorResponse) => {
                        this.asyncErrorValidation.next(err.error)
                    },
                })
            )
    }

    parseDisability(raw: unknown): string[] {
        if (Array.isArray(raw)) return raw.map(String)
        if (typeof raw === 'string') {
            try {
                const arr = JSON.parse(raw)
                return Array.isArray(arr) ? arr.map(String) : []
            } catch {
                return []
            }
        }
        return []
    }

    formatDisability(value: unknown): string {
        if (Array.isArray(value)) return JSON.stringify(value.map(String))
        if (typeof value === 'string') return value
        return '[]'
    }
}
